<template>

<div>

	<div class="page-header">
		<h1><lang labelKey="HEADER_INTERFACES_DASHBOARD"></lang></h1>
	</div>

	<!-- show loading indicator -->
	<loading-indicator :loading="isLoading"></loading-indicator>

  <div v-if="!isLoading" style="padding-bottom: 18px;">

    <div class="interfaces-status-overview">

      <div v-for="(val, name) in data" class="row">

        <div class="label"><lang :labelKey="`INTERFACE-${name}`"></lang></div>

        <div style="display: flex; flex-wrap: wrap;">
          <template v-for="(val2, interfaceName) in val">

            <scroll-to :target="`#${name}-${interfaceName}`">

              <button :class="['button', val2.status]" @click.prevent="scrollTo(name, interfaceName)">

                {{ val2.name }}
								
								<!-- status success -->
								<span :class="['material-symbols-outlined', val2.status]" v-if="val2.status == 'OK'">check</span>

								<!-- for other statuses show a popover -->
								<template v-else>

									<popover trigger="hover">

										<span :class="['material-symbols-outlined', val2.status]">
											<template v-if="val2.status == 'WARNING'">priority_high</template>
											<template v-else-if="val2.status == 'ERROR'">electric_bolt</template>
										</span>

										<div slot="content" v-if="val2.status != 'OK'">
											{{ val2.legend[val2.status] }}
										</div>

									</popover>

								</template>

              </button>

            </scroll-to>

          </template>
        </div>

      </div>

    </div>

    <div class="expandCollapseNav">

      <div>
        <button @click="refresh()" :class="['button is-small', {'is-loading': isRefreshing}]">
          <span class="material-symbols-outlined">
            refresh
          </span>
          aktualisieren
        </button>
      </div>

      <div>

        <button @click="expandAll()" class="button is-small">
          <span class="material-symbols-outlined">expand_all</span>
          alle ausklappen
        </button>

        <button @click="collapseAll()" class="button is-small">
          <span class="material-symbols-outlined">collapse_all</span>
          alle zuklappen
        </button>

      </div>

    </div>


    <div v-for="(value, name) in data" class="interfaces-wrapper">

      <h2><label-name :labelKey="`INTERFACE-${name}`" /></h2>

      <div class="interfaces">
        <div :class="['interface-section', { 'isActive': activeInterface == name+'-'+propName }]" v-for="(prop, propName, index) in data[name]" :id="`${name}-${propName}`">

        <div class="interface-header">

          <h3>
            <span :class="['material-symbols-outlined', prop.status]">
              <template v-if="prop.status == 'OK'">check</template>
              <template v-else-if="prop.status == 'WARNING'">priority_high</template>
              <template v-else-if="prop.status == 'ERROR'">electric_bolt</template>
            </span>
            {{ prop.name }}
          </h3>

          {{ prop.description }}<br>
          {{ prop.schedule }}<br>

          <span style="color: #888">
            <template v-if="prop.type">Typ: {{ prop.type }}</template>
            <template v-if="prop.inputFormat">, Format: {{ prop.inputFormat }}</template>
            <template v-if="prop.source">, Quelle: {{ prop.source }}</template>
            <template v-if="prop.sourceDetails"> ({{ prop.sourceDetails }})</template>
          </span>
        </div>

        <!-- :actived="isActive(propName)" -->
        <collapse>
          <collapse-item :ref="`collapse-${name}-${propName}`" title="Logs anzeigen">
            <table-component :name="propName" :data="prop.logs"></table-component>
          </collapse-item>
        </collapse>

      </div>
      </div>

  	</div>

  </div>


</div>

</template>


<script>
import TableComponent from './TableComponent';

export default {

	name: 'InterfacesDashboard',

  components: {
    TableComponent
  },

	data() {
		return {
			isLoading: true,
      isRefreshing: false,
      data: null,
      activeInterface: null,
		}
	},

	mounted() {
		this.fetchData();
	},

	updated() {

	},

	methods: {

    async refresh() {

      this.isRefreshing = true;

      try {

        const res = await this.axios.get(this.$config.api + 'processLog');

        if(res.data) {
          this.data = res.data;
        } else {
          console.log("error: ", res);
        }

      } catch(err) {
        console.log("err: ", err);
      }

      this.$forceUpdate();
      this.isRefreshing = false;

    },

    expandAll() {
      for (const [key, value] of Object.entries(this.$refs)) {
        if(value[0]._data.isOpen == false) {
          value[0].toggle();
        }
      }
    },

    collapseAll() {
      for (const [key, value] of Object.entries(this.$refs)) {
        if(value[0]._data.isOpen == true) {
          value[0].toggle();
        }
      }
    },

    scrollTo(name, interfaceName) {

      this.activeInterface = name +'-'+interfaceName;

      if(this.$refs['collapse-'+this.activeInterface][0]._data.isOpen == false) {
        this.$refs['collapse-'+this.activeInterface][0].toggle();
      }

    },

		async fetchData() {

      this.isLoading = true;

      try {

        const res = await this.axios.get(this.$config.api + 'processLog');

        if(res.data) {
          this.data = res.data;
        }

      }
      catch(err) {
        console.log("err ...");
      }

      this.isLoading = false;
    },

	}
}
  //  https://mwb.sanodattest.bdata.at/herba/public/api/processLog

</script>


<style lang="scss" scoped>

  span.material-symbols-outlined {

    &.OK {
      background-color: #579866 !important;
    }
    &.WARNING {
      background-color: #f5aa3c !important;
    }
    &.ERROR {
      background-color: #d25555 !important;
    }
  }

  .interfaces-status-overview {
    border-radius: 4px;
    text-align: center;
    background-color: #dee5ea;
    padding: 24px 24px 12px 24px;
    border-left: 6px solid #cad2d7;

    .row {

      display: flex;
      margin-bottom: 6px;

      .label {
        text-align: left;
        min-width: 120px;
        font-weight: bold;
        align-items: center;
        display: flex;
      }

      .button {
        background-color: #f7f7f7;
        margin: 0 6px 6px 0;
        transition: all .3s ease;
        border: none;
				display: flex;
				align-items: center;

        &:hover {
          opacity: .6;
        }

        span.material-symbols-outlined {

					width: 14px; height: 14px;
					display: flex;
					align-items: center;
					justify-content: center;
					line-height: 1;
          color: #FFF;
          border-radius: 50%;
          margin: 0 0 0 6px !important;
          font-size: 75%;
        }

      }

    }
  }

  .expandCollapseNav {
    margin-top: 8px;
    margin-bottom: 48px;
    color: #AAA;
    text-align: right;
    display: flex;
    justify-content: flex-end;
    /*
    span {
      font-size: 12px;
      transition: all .3s ease;
      &:hover {
        color: #000;
      }
    }
    */
    button {
      margin-right: 6px;
      border: 0;

      &:hover {
        background-color: #F5F5F5;

      }
      .material-symbols-outlined {
        font-size: 12px;
        margin-right: 4px;
      }

    }
  }

  .interfaces-wrapper {

    margin-bottom: 52px;

    h2 {
      font-size: 26px;
      margin-bottom: 20px;

      label {
        font-weight: 500;
        ::v-deep span {
          color: #888 !important;
        }
      }
    }

    .interfaces {

      padding-left: 12px;
      border-left: 6px solid #cad2d7;


      .interface-section {
        background-color: #dee5ea;
        padding: 16px;
        margin-bottom: 18px;
        border: 1px solid transparent;
        border-radius: 2px;

        &.isActive {
          animation-name: blink;
          animation-duration: .7s;
          animation-iteration-count: 3;
        }

        .interface-header {
          margin-bottom: 16px;
          line-height: 1.6em;

          h3 {
            color: #444;
            font-weight: 600;
            font-size: 140%;
            margin-bottom: 12px;
            display: flex;
            align-items: center;
            .material-symbols-outlined {
              color: #FFF;
              padding: 2px;
              border-radius: 50%;
              font-size: 90%;
              margin-right: 8px;
            }
          }
        }

        ::v-deep .card {
          box-shadow: none;
          &.is-active {
            .card-header {
              background-color: #F5F5F5;
            }
          }
          .card-header {
              box-shadow: none;
              transition: background .3s ease !important;
              &:hover {
                background-color: #F5F5F5;
              }
          }
          .card-content {
            padding: 0;
          }
        }

      }

    }

  }

@keyframes blink {
  0% { background-color: #dee5ea; border: 1px solid #dee5ea; }
  50% { background-color: #c9cfd7; border: 1px solid #dee5ea; } // #b8bdc0
  100% { background-color: #dee5ea; border: 1px solid #dee5ea; }
}

</style>
